import React, {useState} from 'react';
import ArticleIcon from '@mui/icons-material/Article';
import DownloadIcon from '@mui/icons-material/Download';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const MunicipalCouncilSection = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('all');

    const documents = [
        {
            title: "Budget Municipal 2024",
            category: "Finance",
            date: "15 Jan 2024",
            type: "PDF",
            size: "2.4 MB",
            description: "Budget prévisionnel et plan d'investissement pour l'année 2024"
        },
        {
            title: "Plan Local d'Urbanisme",
            category: "Urbanisme",
            date: "03 Déc 2023",
            type: "PDF",
            size: "8.1 MB",
            description: "Document détaillant les règles d'aménagement et de construction"
        },
        {
            title: "Rapport Environnemental",
            category: "Environnement",
            date: "28 Nov 2023",
            type: "PDF",
            size: "3.7 MB",
            description: "Étude d'impact environnemental et mesures de protection"
        },
        {
            title: "Délibérations du Conseil",
            category: "Administration",
            date: "15 Nov 2023",
            type: "PDF",
            size: "1.2 MB",
            description: "Compte-rendu des décisions prises lors de la dernière session"
        }
    ];

    const categories = ['all', 'Finance', 'Urbanisme', 'Environnement', 'Administration'];

    const filteredDocuments = documents.filter(doc => {
        const matchesSearch = doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            doc.description.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesCategory = selectedCategory === 'all' || doc.category === selectedCategory;
        return matchesSearch && matchesCategory;
    });

    return (
        <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
            <div className="max-w-6xl mx-auto px-4">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        Documents <span className="text-[#228B22]">Municipaux</span>
                    </h2>
                    <p className="text-gray-600">
                        Accédez aux documents officiels et rapports de la municipalité
                    </p>
                </div>

                {/* Search and Filter Section */}
                <div className="mb-8 space-y-4 md:space-y-0 md:flex md:items-center md:justify-between">
                    <div className="relative">
                        <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"/>
                        <input
                            type="text"
                            placeholder="Rechercher un document..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pl-10 pr-4 py-2 w-full md:w-80 rounded-lg border border-gray-200 focus:border-[#228B22] focus:ring-1 focus:ring-[#228B22] outline-none"
                        />
                    </div>

                    <div className="flex items-center gap-2">
                        <FilterListIcon className="text-gray-400"/>
                        <select
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                            className="py-2 px-4 rounded-lg border border-gray-200 focus:border-[#228B22] focus:ring-1 focus:ring-[#228B22] outline-none bg-white"
                        >
                            <option value="all">Toutes les catégories</option>
                            {categories.slice(1).map((category) => (
                                <option key={category} value={category}>{category}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Documents Grid */}
                <div className="grid gap-6">
                    {filteredDocuments.map((doc, index) => (
                        <div
                            key={index}
                            className="group bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 hover:border-emerald-100"
                        >
                            <div className="flex flex-col md:flex-row md:items-center gap-6">
                                {/* Icon */}
                                <div className="flex-shrink-0">
                                    <div
                                        className="w-12 h-12 rounded-lg bg-emerald-50 flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
                                        <PictureAsPdfIcon className="text-[#228B22]"/>
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="flex-grow">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                        {doc.title}
                                    </h3>
                                    <p className="text-gray-600 text-sm mb-3">
                                        {doc.description}
                                    </p>
                                    <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                                        <div className="flex items-center gap-2">
                                            <ArticleIcon className="w-4 h-4"/>
                                            <span>{doc.type} • {doc.size}</span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <CalendarTodayIcon className="w-4 h-4"/>
                                            <span>{doc.date}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Download Button */}
                                <div className="flex-shrink-0">
                                    <button
                                        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-50 text-[#228B22] hover:bg-emerald-100 transition-colors">
                                        <DownloadIcon className="w-5 h-5"/>
                                        <span>Télécharger</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MunicipalCouncilSection;